export const promisesMatchingGiftsFragment = `
participantPromisesMatchingGifts {
    donorLastName
    donorConstituentId
    participantPromisesMatchingGiftsId
    promisedDate
    pdefProgramFundSourceTypeName
    frTotalFlag
    participantDistributions {
      fundraiserPageDisplayAmountType {
        fundraiserPageDisplayAmountTypeId
        name
        description
      }
      fundraiserPageDisplayDonorType {
        fundraiserPageDisplayDonorTypeId
        name
        description
      }
      donorAddress1
      fundType
      participantFundsId
      donorMessageId
      donorState
      donorMatchingCompanyName
      status
      fundDate
      donorEmail
      donorCountry
      amount
      donorAddress2
      donorPhoneNumber
      paymentMethod
      companyMatching
      participantDistributionsId
      donorPostalCode
      donationDescription
      donorMessage
      donorName
      donorAreaCode
      recurringFlag
      donorCity
      source
      honoree
      thankYouNoteSent
      donorDisplayName
      type
      showComments
      hasDcf
    }
    emgmtOcpFundraiserId
    includedInTotal
    pdefProgramFundSourceTypeDescription
    donorName
    promisedAmount
    donorFirstName
}
`;
